import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { ValidationError } from "@cervval.js/common/src/forms/validationError";
import { RegisterValidator, Validator } from "@cervval.js/common/src/services/validation.impl/validators/validator";
import { anyObject, getProp } from "@cervval.js/common/src/tools/any.tools";
import { isBetween } from "@cervval.js/common/src/tools/number.tools";
import { formatMinutesHHMM, formatSecondsHHMM } from "@cervval.js/common/src/tools/time.tools";
import { anyReallyAny } from "@cervval.js/common/tools";
import { render } from "micromustache";
import { DurationPickerRange } from "../../../pickers/durationPicker/durationPicker";

/**
 * List of all english error messages by validator
 */
const _messagesEN = {
    ranges: "{{ value }} isn't a valid duration. Valid durations:"// TODO {{ validRanges }} dans le template
};

type DurationEditorErrorMessageRecord = typeof _messagesEN;

/**
 * List of all french error messages by validator
 */
const _messagesFR: DurationEditorErrorMessageRecord = {
    ranges: "{{ value }} n'est pas une durée valide. Durées valides:"
};

/**
 * DurationEditor error messages per language
 */
export const TIME_EDITOR_ERROR_MESSAGES = {
    "en": _messagesEN,
    "fr": _messagesFR
};

export type DurationInRangesValidatorParams = { ranges: DurationPickerRange[], useSeconds: boolean };
/**
 * This validator ensures a durationInMinutes is contained in given ranges
 * sample use in propertyConfig => validators: validatorEntry(DurationInRangesValidator, true) or validators: { durationInRanges: true } (second option requires this class to be loaded)
 */
@RegisterValidator("durationInRanges")
export class DurationInRangesValidator implements Validator<number, DurationInRangesValidatorParams> {

    /**
     * @returns true if property value is not null or undefined or empty string
     */
    public isValid(property: PropertyConfig, propertyValue: number, validatorParams: DurationInRangesValidatorParams, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, unknown>): boolean {

        if (property.propertyName === "ranges") {
            if (propertyValue == null) { return true; }

            const ranges = validatorParams.ranges;
            // If no range given or empty, all range is enable
            if (ranges.length === 0) { return true; }

            for (const range of ranges) {
                if (isBetween(propertyValue, range.startDuration, range.finishDuration, true)) {
                    return true;
                }
            }
            return false;
        }
        return true;
    }

    /**
     * @returns error message to show when not valid
     */
    public getError(lang: string, property: PropertyConfig, propertyValue: anyReallyAny, validatorParams: DurationInRangesValidatorParams, allProperties: Record<string, PropertyConfig>, allPropertiesValue: Record<string, anyReallyAny>): ValidationError {
        // Get error message from i18n and compile with micromustache
        const errorMessage = getProp<anyObject>(TIME_EDITOR_ERROR_MESSAGES, lang)[property.propertyName] ?? "";

        const format: typeof formatSecondsHHMM | typeof formatMinutesHHMM = validatorParams.useSeconds ? formatSecondsHHMM : formatMinutesHHMM;

        // Look at i18n from object keys
        const errorMessageData = {
            value: format(propertyValue)
        };

        let errorMessageRendered = render(errorMessage, errorMessageData);

        if (validatorParams.ranges.length) {
            errorMessageRendered += " " + validatorParams.ranges.map(range => `${format(range.startDuration)}-${format(range.finishDuration)}`).join(" ");
        }

        return { errorMessage: errorMessageRendered };
    }

}